import { flattenArray, flattenObject } from "./dataFlatteners";

const formatDataForPDF = (data) => {
  const formattedData = {};
  Object.entries(data).map(([key, value]) => {
    if (Array.isArray(value)) {
      return (formattedData[key] = flattenArray(value));
    }
    if (!!value && typeof value === "object") {
      return (formattedData[key] = flattenObject(value));
    }
    return (formattedData[key] = value);
  });
  return formattedData;
};

export default formatDataForPDF;
